var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMappoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0V5.36461C11.7454 5.36461 13.5724 7.2083 13.5724 9.47541C13.5724 11.742 11.7454 13.5862 9.5 13.5862V24.9886L16.9541 15.5286C18.2924 13.82 19 11.7667 19 9.58949C19 4.30196 14.7382 0 9.5 0Z",
    fill: "#CD2A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5724 9.4754C13.5724 7.20831 11.7454 5.36462 9.5 5.36462V13.5862C11.7454 13.5862 13.5724 11.742 13.5724 9.4754Z",
    fill: "#D8D7DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42755 9.47541C5.42755 7.2083 7.25455 5.36461 9.5 5.36461V0C4.26182 0 0 4.30196 0 9.58949C0 11.7667 0.707588 13.82 2.04793 15.5306L9.5 24.9886V13.5862C7.25455 13.5862 5.42755 11.742 5.42755 9.47541Z",
    fill: "#FF3501"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42761 9.4754C5.42761 11.742 7.25464 13.5862 9.50012 13.5862V5.36462C7.25464 5.36462 5.42761 7.20831 5.42761 9.4754Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappoint);
export default __webpack_public_path__ + "static/media/mappoint.051f67d11e231ccc2ddda8b22d86b82e.svg";
export { ForwardRef as ReactComponent };